import { jsxs as t, jsx as C } from "react/jsx-runtime";
const e = ({ width: r, height: l, className: o }) => /* @__PURE__ */ t(
  "svg",
  {
    className: o,
    fill: "none",
    height: l,
    viewBox: "0 0 11 11",
    width: r,
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ C(
        "path",
        {
          d: "M3.65983 2.4915C3.5738 2.49086 3.49148 2.4564 3.43065 2.39557C3.36981 2.33474 3.33536 2.25241 3.33472 2.16639V0.866554C3.33536 0.780527 3.36981 0.698205 3.43065 0.637373C3.49148 0.576541 3.5738 0.542083 3.65983 0.541443C3.74586 0.542083 3.82818 0.576541 3.88901 0.637373C3.94984 0.698205 3.9843 0.780527 3.98494 0.866554V2.16639C3.9843 2.25241 3.94984 2.33474 3.88901 2.39557C3.82818 2.4564 3.74586 2.49086 3.65983 2.4915Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M7.34 2.4915C7.25398 2.49086 7.17165 2.4564 7.11082 2.39557C7.04999 2.33474 7.01553 2.25241 7.01489 2.16639V0.866554C7.01553 0.780527 7.04999 0.698205 7.11082 0.637373C7.17165 0.576541 7.25398 0.542083 7.34 0.541443C7.42603 0.542083 7.50835 0.576541 7.56919 0.637373C7.63002 0.698205 7.66448 0.780527 7.66511 0.866554V2.16639C7.66448 2.25241 7.63002 2.33474 7.56919 2.39557C7.50835 2.4564 7.42603 2.49086 7.34 2.4915Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M9.45876 4.4869H1.54121C1.45194 4.4894 1.36527 4.45671 1.29988 4.3959C1.23449 4.33508 1.19562 4.251 1.19165 4.16179C1.19562 4.07258 1.23449 3.9885 1.29988 3.92769C1.36527 3.86687 1.45194 3.83419 1.54121 3.83668H9.45876C9.54803 3.83419 9.6347 3.86687 9.70008 3.92769C9.76547 3.9885 9.80434 4.07258 9.80832 4.16179C9.80434 4.251 9.76547 4.33508 9.70008 4.3959C9.6347 4.45671 9.54803 4.4894 9.45876 4.4869Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M7.35583 10.4586H3.64333C1.94933 10.4586 0.974609 9.48505 0.974609 7.79167V3.85611C0.974609 2.16455 1.94933 1.19167 3.64333 1.19167H7.35583C9.04983 1.19167 10.0246 2.16455 10.0246 3.85611V7.79167C10.0246 9.48505 9.04983 10.4586 7.35583 10.4586ZM3.64333 1.8865C2.316 1.8865 1.67067 2.53061 1.67067 3.8555V7.79167C1.67067 9.11655 2.316 9.76067 3.64333 9.76067H7.35583C8.68317 9.76067 9.3285 9.11655 9.3285 7.79167V3.85611C9.3285 2.53122 8.68317 1.88711 7.35583 1.88711L3.64333 1.8865Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
export {
  e as Content
};
